BaseCollection  = require('base/collection')

class CountryCollection extends BaseCollection
  url: 'localPresence/countryCodes'

module.exports = CountryCollection
